import { SET_BROKER, IS_SUBMITTING } from './brochureReducer';
import Axios from 'axios';
import { push } from 'react-router-redux';
import { login } from '../../auth/redux/authActions';
import handleErrorResponse from '../../../helpers/handleErrorResponse';

const isSubmitting = (status) => {
  return (dispatch) => {
    dispatch({ type: IS_SUBMITTING, status: status });
  };
};

const retrieveBroker = (token) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(
      `public/brokers/applications/${token}:retrieve?include=broker_contracts,broker_application.documents,organisation.primary_contacts,primary_contacts,users`,
    )
      .then((response) => {
        dispatch({ type: SET_BROKER, values: response.data });
        dispatch(isSubmitting(false));
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(
          error,
          'There was an error retrieving your broker application, please contact Just Travel.',
        );
      });
  };
};

const agreeContract = (token) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(`public/brokers/applications/${token}:agree`)
      .then(() => {
        dispatch(isSubmitting(false));
        dispatch(push(`/broker/set-password/${token}`));
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(
          error,
          'There was an error retrieving your broker application, please contact Just Travel.',
        );
      });
  };
};

const activateBroker = (token, values) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post(`public/brokers/applications/${token}:activate`, values)
      .then(() => {
        dispatch(isSubmitting(false));
        dispatch(login(values.meta.email, values.meta.password));
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(
          error,
          'There was an error retrieving your broker application, please contact Just Travel.',
        );
      });
  };
};

const savePublicBrokerApplication = (values, setComplete) => {
  if (setComplete) {
    values.data.attributes.complete = true;
    values.data.attributes.metadata.generate_documents = true;
  }
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post('public/brokers/applications', values)
      .then(() => {
        dispatch(isSubmitting(false));
        //toastr.success('Broker App  Saved');
        return true;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to save ');
      });
  };
};

const saveWorkingWithUsForm = (values) => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.post('public/brokers/contact', values)
      .then((response) => {
        dispatch(isSubmitting(false));
        //toastr.success('Broker App  Saved');
        return response.data.data.attributes.reference;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to save ');
      });
  };
};

const getAdminBrokerRoleId = () => {
  return (dispatch) => {
    dispatch(isSubmitting(true));
    return Axios.get('public/broker-roles?filter[name]=admin')
      .then((response) => {
        dispatch(isSubmitting(false));
        return response.data.data[0].id;
      })
      .catch((error) => {
        dispatch(isSubmitting(false));
        handleErrorResponse(error, 'Failed to save ');
      });
  };
};

const getEmptyBrokerApplicationFormDocument = () => {
  return () => {
    return Axios.get('public/brokers/broker-application-form').then((response) => {
      return response.data.meta.url;
    });
  };
};

export const actions = {
  retrieveBroker,
  agreeContract,
  activateBroker,
  savePublicBrokerApplication,
  getAdminBrokerRoleId,
  saveWorkingWithUsForm,
  isSubmitting,
  getEmptyBrokerApplicationFormDocument,
};
